export default "__VITE_ASSET__DNJxaDPl__"